"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clsx = void 0;
var tailwind_merge_1 = require("tailwind-merge");
function clsx() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    var classes = inputs.filter(Boolean).join(' ');
    return (0, tailwind_merge_1.twMerge)(classes);
}
exports.clsx = clsx;
